module.exports = __webpack_public_path__ + "img/gjjc.a40dca51.png";